import React, { useEffect, useLayoutEffect, useState, useCallback, useRef } from 'react';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/indexRevamp';
import Keyboard from '@components/KeyboardV2';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { LABEL } from '../../../veriables';
import { lowerCase } from 'lodash';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { ReactComponent as SearchIcon } from '@assets/images/SearchDetails.svg';
import 'react-simple-keyboard/build/css/index.css';
import cn from 'classnames';
import Styles from './createtableCopy.module.scss';
import { TouchableButton, TouchableDiv } from '../../common/Touchable/index';
import EventEmitter from '@utility/eventSubscribers';

const CreateTable = props => {
  // Props Destructuring
  const {
    type,
    maxLength,
    isAlpha,
    name,
    placeholder,
    onSubmit,
    validate,
    hideGuestCount = false,
    countryCode,
    handleCountryCodeChange,
    phoneNumberMaxLength,
    isTableTop,
    deviceGroup,
    orderingPortraitOrientation,
    order,
    showTableSearchField,
    setShowTableSearchField,
    jobTypeId,
    openManagerCheck,
    onCloseTable,
    searchData,
    serverAppTheme,
    isCounter,
    isMenuTop,
    isDriveThru,
    isCallCenter,
    isTipOnly,
    isTipOnlyEnabled,
    setIsTipOnlyEnabled
  } = props;
  // State Management
  const [keyboardType, setKeyboardType] = useState(
    deviceGroup?.inputFields?.phoneNumberEnabled &&
      !deviceGroup?.inputFields?.nameEnabled
      ? 'numericDefaultWithDone'
      : 'numericAlpha'
  );
  
  const [typed, setTyped] = useState({});
  const [inputs, setInputs] = useState({
    [name]: '',
  });
  const isPhoneOnly =
    deviceGroup?.inputFields?.phoneNumberEnabled &&
    !deviceGroup?.inputFields?.nameEnabled;

  const [inputName, setInputName] = useState(
    isPhoneOnly ? 'phoneNumber' : name
  );
  const defaultGuestCount = deviceGroup?.defaultGuestCount || 1;
  const [count, setCount] = useState(defaultGuestCount);
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [isDoneClick, setIsDoneClick] = useState(false);
  const useAlphaNumericKeypad =
    deviceGroup?.serverAppSettings?.useAlphaNumericKeypad;

  // Refs so callbacks don't depend on keystroke-level state, matching
  // the same pattern used in KeyboardV2/hooks/useKeyClickHandler.js
  const typedRef = useRef(typed);
  typedRef.current = typed;
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;

  let filteredArr = [];
  const isSearchEnabled =
    deviceGroup?.serverAppSettings?.enableTableNumberSearch;
  const phoneNumber = typed?.phoneNumber?.length > 0;
  const counterUser = window.sessionStorage.getItem('counterName');
  const counterPhone = window.sessionStorage.getItem('counterPhone');

  // useLayoutEffect(() => {
  //   if (window.ReactNativeWebView) {
  //       if (orderingPortraitOrientation) {
  //         EventEmitter.changeOrientation({
  //           orientation: "portrait"
  //         })
  //       } else {
  //         EventEmitter.changeOrientation({
  //           orientation: "landscape"
  //         })
  //       }
  //   }
  // }, [!orderingPortraitOrientation])

  // React Hooks
  useEffect(() => {
    if (isCounter || isDriveThru) {
      if (!props.isOpen) return;
    
      const cName = counterUser || '';
      const phone = counterPhone || '';
    
      setTyped({
        tabName: cName,
        [name]: cName,
        phoneNumber: getFormatedPhoneNumber(phone),
      });
    
      setInputs({
        tabName: cName,
        [name]: cName,
        phoneNumber: getFormatedPhoneNumber(phone),
      });
    }
  }, [props.isOpen]);  

  useEffect(() => {
    if (isDoneClick && isAlpha) {
      setKeyboardType('numericAlpha');
      setIsDoneClick(false);
    }
  }, [isDoneClick, isAlpha]);

  useEffect(() => {
    if (isAlpha) {
      setKeyboardType('numericAlpha');
    } else {
      setKeyboardType(
        deviceGroup?.inputFields?.phoneNumberEnabled &&
          !deviceGroup?.inputFields?.nameEnabled
          ? (isCounter || isDriveThru || isCallCenter)
            ? 'numericAlpha'
            : 'number'
          : 'textDefaultCaps'
      );
    }
  }, [type]);


  // Methods
  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  const submit = () => {
    const validateData = {
      ...typed,
      guestNumber: isTableTop || hideGuestCount ? 1 : count,
    };
    validate(validateData)
      .then(res => {
        validatePhoneNumber()
          .then(() => {
            if (isMenuTop) {
              const validateData = {
                ...typed,
                guestNumber: isTableTop || hideGuestCount ? 1 : count,
              };
              validate(validateData)
                .then(res => {
                  if (!res?.isCheckModalOpenFlag) onSubmit(res.value);
                })
                .catch(err => {
                  props.setErrorPopUp({
                    res: err.message,
                    noErrorTxt: true,
                  });
                });
            } else {
              if (!res?.isCheckModalOpenFlag) onSubmit(validateData);
            }
          })
          .catch(err => {
            if (err.message?.length > 0) {
              props.setErrorPopUp({
                res: err.message,
                noErrorTxt: true,
              });
            }
          });
      })
      .catch(err => {
        if (err.message?.length > 0) {
          props.setErrorPopUp({
            res: err.message,
            noErrorTxt: true,
          });
        }
      });
  };

  // submitRef lets onClickBtn always call the latest submit without depending on it
  const submitRef = useRef(null);
  submitRef.current = submit;

  // Stable across keystrokes — reads mutable state via refs, not closure deps.
  // countryCode is the only true dep (affects phone number formatting).
  const onClickBtn = useCallback(e => {
    const currentTyped = typedRef.current;
    const currentInputs = inputsRef.current;
    const currentInputName = inputNameRef.current;

    // Enforce maxLength here (not via typed prop) to avoid keyboard re-renders.
    // Control keys are always allowed through regardless of length.
    const controlKeys = new Set(['{bksp}', '{done}', '{cancel}', '{continue}', '{swipe}', '{space}', '{tab}', '{return}', '{enter}', '{surveyBack}', '{bin}', '{emptySpace}']);
    if (!controlKeys.has(e)) {
      const currentVal = currentTyped[currentInputName] || '';
      const limit = currentInputName === 'phoneNumber' ? phoneNumberMaxLength : maxLength;
      if (Number(limit) > 0 && currentVal.length >= Number(limit)) return;
    }

    const value =
      e === '{continue}'
        ? { [currentInputName]: currentTyped[currentInputName] }
        : e === '{bksp}'
        ? { ...currentTyped, [currentInputName]: currentTyped[currentInputName]?.slice(0, -1) }
        : {
            ...currentTyped,
            [currentInputName]: currentTyped[currentInputName]
              ? currentTyped[currentInputName].concat(e)
              : ''.concat(e),
          };
    if (e === '{continue}') {
      submitRef.current();
    }
    setTyped(value);
    setInputs({
      ...currentInputs,
      [currentInputName]:
        currentInputName === 'phoneNumber' && Number(countryCode) === 1
          ? getFormatedPhoneNumber(value[currentInputName])
          : value[currentInputName],
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, phoneNumberMaxLength, maxLength]);

  const getInputValue = inputNameDat => {
    const currentValue = inputs[inputNameDat] ?? '';

    if (currentValue.length >= 2) {
      filteredArr = searchData?.filter(
        el =>
          !el.tab &&
          el?.stationName &&
          lowerCase(el.stationName).includes(lowerCase(currentValue))
      );
    }
    return inputs[inputNameDat] || '';
  };

  const validatePhoneNumber = () => {
    return new Promise((resolve, reject) => {
      if (
        deviceGroup?.inputFields?.phoneNumberRequired &&
        deviceGroup?.inputFields?.phoneNumberEnabled &&
        (inputs[name]?.length === 0 || inputs[name]?.length > 0) &&
        !inputs?.phoneNumber
      ) {
        reject(new Error('Phone number required'));
      } else if (
        Number(countryCode) === 1 &&
        inputs &&
        inputs?.phoneNumber &&
        inputs?.phoneNumber?.length !== 12
      ) {
        reject(
          new Error(`Phone number length must be ${phoneNumberMaxLength}`)
        );
      } else {
        resolve();
      }
    });
  };

  const handleBlur = () => {
    setSwipedDown(true);
    if (document.querySelector(`#${name}`)) {
      const element = document.querySelector(`#${name}`);
      element.blur();
    }
    if (document.querySelector('#phoneNumber')) {
      document.querySelector('#phoneNumber').blur();
    }
  };

  const setEmpty = data => {
    setTyped(prev => ({
      ...prev,
      [data]: '',
    }));
    setInputs(prev => ({
      ...prev,
      [data]: '',
    }));
  };

  const returnMaxLength = () => {
    if (inputs && inputs.phoneNumber && inputs.phoneNumber.includes('-')) {
      return 10;
    }
    return phoneNumberMaxLength;
  };

  const getEmployeeFullName = (firstName, lastName, maxLength) => {
    const fullName = firstName || '' + ' ' + lastName || '';
    return fullName.length > maxLength
      ? fullName.substring(0, maxLength) + '...'
      : fullName;
  };
  return (
    <div
      className={cn(
        !orderingPortraitOrientation
          ? 'col-10 p-0 h-100 d-flex flex-column m-auto'
          : 'col-12 p-0 h-100 d-flex flex-column m-0'
      )}
    >
      <div
        className={cn(
          'row align-self-center justify-self-center mb-2 align-items-center justify-content-center mx-3',
          deviceGroup?.inputFields?.phoneNumberEnabled ? '' : 'pt-20', isTipOnlyEnabled ? 'w-100' : ''
        )}
        style={{top: orderingPortraitOrientation ? '18vh' : '', position: orderingPortraitOrientation ? 'absolute' : ''}}
      >
        <div className={cn("col-12 p-0 mx-0 mb-1", !orderingPortraitOrientation ? 'row' : '')}>
          {!orderingPortraitOrientation ?
          <div 
            className={cn(
              !orderingPortraitOrientation
                ? 'my-auto'
                : 'mb-2 align-items-end justify-content-start',
              'col-6 p-0 row mx-0'
            )}
            style={{ textAlign: 'initial' }}
          >
            
          </div>: ''}
          {!hideGuestCount && !isTipOnlyEnabled && (
            <div
              className={cn(
                !orderingPortraitOrientation ? 'justify-content-end col-6 p-0 row' : 'justify-content-center d-flex p-0 pr-4',
              )}
            >
              <div
                className={cn("fs_24 fw-400 my-1", !orderingPortraitOrientation ? 'text-left pl-4 ml-2' : '')}
                style={{ color: serverAppTheme?.primary_text }}
              >
                {LABEL().GUEST_COUNT}
              </div>
              <div className="row ml-3">
                <TouchableButton
                  className={cn(Styles.incDecButton, 'rounded mr-2')}
                  style={{
                    background: serverAppTheme?.primaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  type="button"
                  onClick={() => count > 1 && setCount(count - 1)}
                  disabled={count <= 1}
                  aria-label="minusCartQtyBtn"
                >
                  {/* Replacing text to svg by #Rahul */}
                  {/* - */}
                  <i className="fas fa-minus justify-content-center align-items-center" />
                </TouchableButton>
                <div
                  className="fs_24 fw-700 d-flex align-items-center mx-2"
                  style={{ color: serverAppTheme?.primary_text, width: '15px' }}
                >
                  {count}
                </div>
                <TouchableButton
                  className={cn(Styles.incDecButton, 'rounded ml-3')}
                  style={{
                    background: serverAppTheme?.primaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  type="button"
                  onClick={() => setCount(count + 1)}
                  aria-label="plusCartQtyBtn"
                >
                  {/* Replacing text to svg by #Rahul */}
                  <i className="fas fa-plus justify-content-center align-items-center" />
                  {/* + */}
                </TouchableButton>
              </div>
            </div>
          )}
        </div>
        {/* name box */}
        {((hideGuestCount && deviceGroup?.inputFields?.nameEnabled) ||
          !hideGuestCount) && (
          <div className={cn('col-12 p-0 my-1 mb-0 position-relative', isTipOnlyEnabled ? 'px-12' : '')}>
            <input
              id={name}
              type="text"
              name={name}
              style={{
                background: serverAppTheme?.inputBg,
                borderBottom: serverAppTheme?.inputBorder_Bottom,
                color: serverAppTheme?.primary_text,
                '--placeholder-color': serverAppTheme?.input_placeholder,
                paddingLeft: isSearchEnabled ? '4rem' : '1rem',
                outline: 'none',
                boxShadow: 'none',
                height: orderingPortraitOrientation ? '64px' : ''
              }}
              className={cn(
                Styles.inputField,
                'col-12 form-control py-2 d-flex justify-content-center align-items-center',
                hideGuestCount ? 'text-left' : 'text-left fs_26'
              )}
              placeholder={placeholder}
              value={getInputValue(name)}
              onFocus={() => {
                handleBlur();
                setInputName(name);
                (isCounter || isDriveThru) && setKeyboardType('textWithoutNumeric');
              }}
              readOnly
            />
            {isSearchEnabled && deviceGroup !== null && (
              <div className={cn(Styles.search_icon, 'position-absolute')}>
                <SearchIcon
                  stroke={serverAppTheme?.iconcolor}
                  alt="s"
                  width={20}
                  height={20}
                />
              </div>
            )}
            {typed[name]?.length > 0 && (
              <TouchableDiv
                role="presentation"
                className="position-absolute"
                style={{ right: '18px', top: !orderingPortraitOrientation ? '6px' : '15px' }}
                onClick={() => {
                  setInputName(name);
                  setEmpty(name);
                  (isCounter || isDriveThru) && setKeyboardType(type);
                }}
              >
                <Cross fill={serverAppTheme?.iconcolor} aria-hidden="true" />
              </TouchableDiv>
            )}
            {isSearchEnabled &&
              deviceGroup !== null &&
              filteredArr?.length >= 1 &&
              showTableSearchField && (
                <div
                  className="w-100 position-absolute overflowY fs_16 pt-1"
                  style={{
                    backgroundColor: serverAppTheme?.popUp_bg,
                    zIndex: '100',
                    maxHeight: '85px',
                    border: serverAppTheme?.popupBorder,
                    color: 'black',
                    cursor: 'pointer',
                  }}
                >
                  {filteredArr?.map(el => (
                    <div
                      style={{
                        backgroundColor: serverAppTheme?.drop_down_selected,
                        color: serverAppTheme?.primary_text,
                      }}
                      className="w-100 d-flex py-1 mb-1"
                      role="button"
                      tabIndex="0"
                      onClick={() => order(el)}
                    >
                      <div style={{ width: '20%' }}>
                        {el?.stationName || el?.stationNumber}
                      </div>
                      <div style={{ width: '20%' }}>{el?.number}</div>
                      <div style={{ width: '45%' }}>
                        {getEmployeeFullName(
                          el?.employeeFirstName,
                          el.employeeLastName,
                          18
                        )}
                      </div>
                      <div style={{ width: '15%' }}>
                        {LABEL().CURRENCY_SYMBOL + el?.unpaidAmount}
                      </div>
                    </div>
                  ))}
                </div>
              )}
          </div>
        )}
        {/* phonenumber box */}
        {hideGuestCount && deviceGroup?.inputFields?.phoneNumberEnabled && (
          <div className={cn('col-12 p-0 my-2 position-relative')}>
            <PhoneNumberComponent
              countryCode={countryCode}
              handleCountryCodeChange={e => {
                handleCountryCodeChange(e);
                setEmpty('phoneNumber');
              }}
              maxMenuHeight={200}
              isCounter={hideGuestCount}
              serverAppTheme={serverAppTheme}
              isDriveThru={hideGuestCount}
            />
            <input
              id="phoneNumber"
              name="phoneNumber"
              className={cn(
                hideGuestCount ? Styles.countertopInput : Styles.tableInput,
                'col-12 form-control py-2 rounded-0'
              )}
              style={{
                borderBottom: serverAppTheme?.inputBorder_Bottom,
                background: serverAppTheme?.inputBg,
                color: serverAppTheme?.primary_text,
                '--placeholder-color': serverAppTheme?.input_placeholder,
              }}
              type="text"
              placeholder={
                (deviceGroup?.inputFields?.phoneNumberRequired
                  ? `${LABEL().ENTER_PHONE_NUMBER} (${LABEL().REQUIRED})`
                  : '') ||
                (deviceGroup?.inputFields?.phoneNumberEnabled &&
                  `${LABEL().ENTER_PHONE_NUMBER} (${LABEL().OPTIONAL})`)
              }
              value={getInputValue('phoneNumber')}
              onFocus={() => {
                handleBlur();
                setKeyboardType((isCounter || isDriveThru || isCallCenter) ? 'numericAlpha' : 'number');
                setInputName('phoneNumber');
              }}
              autoFocus={keyboardType == 'numericDefaultWithDone'}
              readOnly
            />
            {phoneNumber && (
              <TouchableDiv
                role="presentation"
                className="position-absolute"
                style={{ right: '18px', top: !orderingPortraitOrientation ? '6px' : '15px' }}
                onClick={() => {
                  setEmpty('phoneNumber');
                  setInputName('phoneNumber');
                }}
              >
                <Cross fill={serverAppTheme?.iconcolor} aria-hidden="true" />
              </TouchableDiv>
            )}
          </div>
        )}

        {isSwipedDown && (
          <div
            className={cn('w-100 align-items-end position-fixed', !orderingPortraitOrientation ? 'p-0' : 'px-3')}
            style={{ bottom: !orderingPortraitOrientation ? '70px' : '', left: '0', outline: 'none', top: orderingPortraitOrientation ? '39%' : '' }}
            role="button"
            tabIndex="0"
            onClick={event => {
              event.stopPropagation();
              setShowTableSearchField && setShowTableSearchField(true);
            }}
          >
            <Keyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={onClickBtn}
              type={
                inputName === 'tableNumber' && !useAlphaNumericKeypad
                  ? keyboardType === 'textDefaultCaps'
                    ? 'textDefaultCaps'
                    : 'numericAlpha'
                  : (inputName === 'phoneNumber' || (deviceGroup?.inputFields?.phoneNumberEnabled && !deviceGroup?.inputFields?.nameEnabled))
                  ? 'numericAlpha'
                  : 'textDefaultCaps'
              }
              // typed={typed[inputName] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="fs-18"
              customClass={`h-auto mt-auto p-2`}
              maxLength={
                inputName === 'phoneNumber' ? returnMaxLength() : maxLength
              }
              spacebtn={orderingPortraitOrientation && Styles.spacebtn}
              screenType="checkCreate"
              isAlphaNumericFlag={true}
              setIsDoneClick={setIsDoneClick}
              tableKeyHeight={true}
              callApi={true}
            />
          </div>
        )}
        <div
          className={cn(
            'col-12 d-flex align-items-center justify-content-center position-fixed bottom-0 start-0',
            Styles.btnPosition
          )}
        >
          <div className={cn("pr-1", orderingPortraitOrientation ? 'pl-0 col-6' : 'col-5')}>
            <TouchableButton
              type="button"
              className={cn(
                'px-0 mb-3 mt-2 rounded btn-ripple fs_24 fw-600 w-100', !orderingPortraitOrientation ? 'btn44' : 'btn68'
  )}
              style={{
                backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                border: serverAppTheme?.cancleBtn_Border,
                color: serverAppTheme?.cancleBtn_font,
              }}
              onClick={e => {
                e.preventDefault();
                // setEmpty(name)
                setTimeout(() => {
                  if (!isCounter) {
                    window.sessionStorage.removeItem('tempModalValue')
                    window.sessionStorage.removeItem('counterName')
                  }
                  onCloseTable('click');
                }, 100);
              }}
              rippleEffect={true}
            >
              {isDriveThru ? LABEL().DT_CANCEL : LABEL().CANCEL}
            </TouchableButton>
          </div>
          <div className={cn("pl-1", orderingPortraitOrientation ? 'pr-0 col-6' : 'col-5')}>
            <TouchableButton
              type="submit"
              className={
                cn('btn-ripple fs_24 fw-600 w-100 d-flex align-items-center justify-content-center mb-3 mt-2', !orderingPortraitOrientation ? 'btn44' : 'btn68')
              }
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={e => {
                e.preventDefault();
                submit();
              }}
              rippleEffect={true}
            >
              <span className={cn("fw-600 w-100", !orderingPortraitOrientation ? 'fs_24' : 'fs_28')}>{isDriveThru ? LABEL().DT_CONTINUE : LABEL().OT_CONTINUE}</span>
            </TouchableButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CreateTable);
